/* ========================================================================
   Navigation
 ========================================================================== */

app.navigation = (function () {
  'use strict';

  function init() {
    initMenu();
    initSubmenu();
    initLangSwitch();
  }

  const KEY_ENTER = 'Enter';
  const KEY_SPACE = 'Space';
  const KEY_ESCAPE = 'Escape';

  const _mainNav = document.querySelector('[data-main-nav]');
  const _trigger = document.querySelector('[data-main-nav-trigger]');
  const _container = document.querySelector('[data-main-nav-container]');
  const _body = document.querySelector('body');
  const _scrollWatcher = document.querySelector('[data-scroll-watcher]');

  function initMenu() {
    if (!_trigger || !_container) return;

    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('pageWrapper')) {
        closeMenu(false);
      }
    });

    _trigger.addEventListener('click', (event) => {
      toggleMenu(false);
    });

    _trigger.addEventListener('keydown', (event) => {
      switch (event.code) {
        case KEY_ENTER:
        case KEY_SPACE:
          event.preventDefault();
          toggleMenu(true);
      }
    });

    _container.addEventListener('keydown', (event) => {
      if (event.code === KEY_ESCAPE) {
        closeMenu(true);
      }
    });

    // navigation observer
    if (_scrollWatcher) {
      const navObserver = new IntersectionObserver(toggleStickyNav);
      navObserver.observe(_scrollWatcher);
    }
  }

  function toggleStickyNav() {
    if (_scrollWatcher.getBoundingClientRect().top <= -1) {
      _mainNav.classList.add('is-sticky');
      // closeLangSwitch();
    } else {
      _mainNav.classList.remove('is-sticky');
    }
  }

  function toggleMenu(setFocus) {
    setFocus = setFocus || false;

    if (_trigger.getAttribute('aria-expanded') === 'false') {
      openMenu(setFocus);
    } else {
      closeMenu(setFocus);
    }
  }

  function openMenu(setFocus) {
    setFocus = setFocus || false;

    _container.classList.add('is-open');
    _container.style.visibility = 'visible';
    _body.classList.add('has-open-menu');

    // a11y: switch focus to first link
    const firstMenuItem = _container.querySelector('.menu__link');
    if (setFocus && firstMenuItem) firstMenuItem.focus();

    // a11y: update aria attributes
    _trigger.setAttribute('aria-label', _trigger.dataset.closeText);
    _trigger.setAttribute('aria-expanded', true);

    // DATALAYER
    app.dataLayer.pushEvent('menuOpen', {
      pageUrl: window.location.pathname,
    });
  }

  function closeMenu(setFocus) {
    setFocus = setFocus || false;

    resetSubmenu();

    _container.classList.remove('is-open');
    _body.classList.remove('has-open-menu');

    // a11y: switch focus back to trigger
    if (setFocus) _trigger.focus();

    // a11y: update aria attributes
    _trigger.setAttribute('aria-label', _trigger.dataset.openText);
    _trigger.setAttribute('aria-expanded', false);

    window.setTimeout(() => {
      _container.style.visibility = 'hidden';
    }, 500);

    // DATALAYER
    app.dataLayer.pushEvent('menuClose', {
      pageUrl: window.location.pathname,
    });
  }

  function initSubmenu() {
    const toggles = document.querySelectorAll('[data-menu-item-toggle]');

    if (!toggles) return;

    toggles.forEach((toggle) => {
      const parent = toggle.parentNode.parentNode;
      const subnav = parent.querySelector('[data-menu-item-sub]');

      if (!parent || !subnav) return;

      toggle.addEventListener('click', (event) => {
        event.preventDefault();

        if (parent.classList.contains('is-open') === false) {
          // close all open submenus
          resetSubmenu();

          parent.classList.add('is-open');
          util.slideDown(subnav, 250);

          // a11y: update aria attributes
          toggle.setAttribute('aria-label', toggle.dataset.closeText);
          toggle.setAttribute('aria-expanded', true);
        } else {
          util.slideUp(subnav, 250);
          parent.classList.remove('is-open');

          // a11y: update aria attributes
          toggle.setAttribute('aria-label', toggle.dataset.openText);
          toggle.setAttribute('aria-expanded', false);
        }
      });
    });
  }

  function resetSubmenu() {
    const toggles = document.querySelectorAll(
      '[data-menu-item-toggle][aria-expanded="true"]'
    );

    if (!toggles) return;

    toggles.forEach((toggle) => {
      const parent = toggle.parentNode.parentNode;
      const subnav = parent.querySelector('[data-menu-item-sub]');

      if (!parent || !subnav) return;

      util.slideUp(subnav, 250);
      parent.classList.remove('is-open');

      // a11y: update aria attributes
      toggle.setAttribute('aria-label', toggle.dataset.openText);
      toggle.setAttribute('aria-expanded', false);
    });
  }

  const _langTrigger = document.querySelector('[data-lang-switch-trigger]');
  const _langContainer = document.querySelector('[data-lang-switch-container]');

  function initLangSwitch() {
    if (!_langTrigger || !_langContainer) return;

    _langTrigger.addEventListener('click', (event) => {
      event.preventDefault();

      if (_langTrigger.getAttribute('aria-expanded') === 'false') {
        openLangSwitch();
      } else {
        closeLangSwitch(false);
      }
    });

    document.addEventListener('click', (event) => {
      const classNames = event.target.getAttribute('class');

      if (classNames !== null && classNames.indexOf('langSwitch') === -1) {
        closeLangSwitch(false);
      }
    });

    _langContainer.addEventListener('keydown', (event) => {
      if (event.code === KEY_ESCAPE) {
        closeLangSwitch(true);
      }
    });
  }

  function openLangSwitch() {
    _langContainer.classList.add('is-open');
    _langContainer.style.visibility = 'visible';

    // a11y: update aria attributes
    _langTrigger.setAttribute('aria-label', _langTrigger.dataset.closeText);
    _langTrigger.setAttribute('aria-expanded', true);
  }

  function closeLangSwitch(setFocus) {
    setFocus = setFocus || false;
    _langContainer.classList.remove('is-open');

    // a11y: switch focus back to trigger
    if (setFocus) _langTrigger.focus();

    // a11y: update aria attributes
    _langTrigger.setAttribute('aria-label', _langTrigger.dataset.openText);
    _langTrigger.setAttribute('aria-expanded', false);

    window.setTimeout(() => {
      _langContainer.style.visibility = 'hidden';
    }, 500);
  }

  // Expose public functions and variables
  return {
    initMenu: initMenu,
    init: init,
  };
})();
